import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { MessagesService } from '../ui/messages.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private endpoint = environment.apiUrl;

  constructor(private http: HttpClient, private messages: MessagesService) {}

  forgotPassword(email: string) {
    return this.http.post(`${this.endpoint}/auth/forgot-password`, { email });
  }

  resetPassword(_id: string, password: string, token: string) {
    return this.http.post(`${this.endpoint}/auth/reset-password`, { _id, newPassword: password, token });
  }
}
